import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripVertical } from '@fortawesome/free-solid-svg-icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function OrderedRow({ row, index, disabled, selecting, selected, moving, onSelect, children }) {
  const { attributes, listeners, setNodeRef, transform, transition, isOver } = useSortable({ id: row.id, disabled });
  const content = (
    <div
      ref={setNodeRef}
      className={`circle-row ${selected ? 'selected' : ''}`}
      style={{ transform: CSS.Transform.toString(transform), transition, opacity: moving ? 0.4 : 1 }}
    >
      {selecting && (
        <input
          type='checkbox'
          aria-label={`Select ${row.title || row.user?.name || 'row ' + (index + 1)}`}
          checked={selected}
          disabled={disabled}
          onChange={onSelect}
        />
      )}
      <button
        type='button'
        className='circle-grip'
        aria-label={`Move ${row.title || row.user?.name || 'row ' + (index + 1)}`}
        disabled={disabled}
        {...attributes}
        {...listeners}
      >
        <FontAwesomeIcon icon={faGripVertical} />
      </button>
      {children}
    </div>
  );
  return (
    <div className={`circle-rank-slot ${isOver ? 'circle-rank-slot-target' : ''}`}>
      <span className='circle-display-rank'>{index + 1}</span>
      {content}
    </div>
  );
}

OrderedRow.propTypes = {
  row: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  selecting: PropTypes.bool,
  selected: PropTypes.bool,
  moving: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  children: PropTypes.node
};

export default OrderedRow;
